export const DOC_FLOW_BUILDING_GROUP_FIELD_NAME = 'building_group'
